const metadataSlice = {
    navButtons: {
        builder: true,
        preset: true
    }
}

export default metadataSlice
export { metadataSlice }



// WEBPACK FOOTER //
// ./src/app/configuration/Hyundai/config/components/selection/MetadataSlice/index.js